






































import Vue from "vue";
import ApiService from "@/services/ApiService";
import TravelFeature from "@/components/user_portal_components/TravelFeature.vue";
import SingleTravelFeature from "@/modals/SingleTravelFeatureModal.vue";
export default Vue.extend({
  components: {
    TravelFeature,
  },
  props: {
    queryParams: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      data: [],
      categories: [],
      loading: true,
      schools: {},
      councils: {},
      is_staff: false,
      native: false,
    };
  },
  methods: {
    getData() {
      ApiService.generalApi.getTravelFeatures(this.queryParams).then((resp) => {
        const data = resp.data.data;
        this.schools = resp.data.schools.reduce(
          (obj, item) => Object.assign(obj, { [item.id]: { ...item } }),
          {}
        );
        if (resp.data.councils.length > 0) {
          const councils = {};
          resp.data.councils.forEach((element) => {
            councils[element.id] = element;
          });
          this.councils = councils;
          // console.log("Councils", councils);
        }
        this.formatFeatures(data);
        this.loading = false;
      });
    },
    editSingleTravelFeature(payload) {
      this.$modal.show(
        SingleTravelFeature,
        {
          options: {
            // profilePicture: true,
          },
          item: payload.block,
          queryParams: this.queryParams,
          category: payload.category,
          section: payload.section,
          categories: this.categories
            .slice()
            .map((itm) => ({ id: itm.id, name: itm.category })),
          closeHandler: () => {
            // this.$modal.hide(SingleTravelFeature, { closedByButton: true });
            // reject();
          },
        },
        {
          draggable: false,
          transition: "fadeDown",
          // scrollable: true,
          // height: 500,
          adaptive: true,
          width: 700,
          minHeight: 500,
          height: "auto",
          // pivotY: 0
        },
        {
          "before-close": this.beforeClose,
        }
      );
    },
    beforeClose() {
      this.getData();
    },
    formatFeatures(data) {
      const categories = data
        .filter((i) => !i.section_id)
        .map((itm) => {
          itm.blocks = [];
          return itm;
        })
        .sort((a, b) => {
          return a.order - b.order;
        });
      const categoriesOnly = JSON.parse(JSON.stringify(categories));
      const items = data.filter((i) => i.section_id >= 0);
      items.forEach((element) => {
        let image = "";
        if (!element.school_id && !element.council_id && !element.image) {
          image =
            "https://s3-eu-west-1.amazonaws.com/home-run/other/logo_small.png";
        } else if (element.image) {
          image = element.image.path;
        } else if (element.school_id) {
          if (this.schools[element.school_id]) {
            image = this.schools[element.school_id].image;
          }
        } else if (element.council_id) {
          if (this.councils[element.council_id]) {
            image = this.councils[element.council_id].image;
          }
        }
        if (element.link && element.link.substring(0, 4) != "http") {
          element.link = "https://" + element.link;
        }
        element.image = image;
        const index = categories
          .map(function (e) {
            return e.id;
          })
          .indexOf(element.section_id);
        if (index > -1) {
          if (
            !categories[index].blocks ||
            categories[index].blocks.length === 0
          ) {
            categories[index].blocks = [];
            categories[index].bgColor = this.convertHex(
              categories[index].color,
              0.1
            );
            categories[index].borderColor = this.convertHex(
              categories[index].color,
              0.25
            );
          }
          categories[index].blocks.push(element);
        }
      });
      this.data = categories;
      this.categories = categoriesOnly;

      this.$nextTick(() => {
        this.$refs[categories[0].category][0].toggle();
      });
    },
    toggled(category) {
      if (this.openedCategory != category && this.openedCategory != null) {
        setTimeout(() => {
          this.$refs[this.openedCategory][0].close();
          this.openedCategory = category;
        }, 100);
      } else {
        this.openedCategory = category;
      }
    },
    convertHex(hexCode, opacity = 1) {
      let hex = hexCode.replace("#", "");

      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }

      const r = parseInt(hex.substring(0, 2), 16),
        g = parseInt(hex.substring(2, 4), 16),
        b = parseInt(hex.substring(4, 6), 16);

      /* Backward compatibility for whole number based opacity values. */
      if (opacity > 1 && opacity <= 100) {
        opacity = opacity / 100;
      }

      return "rgba(" + r + "," + g + "," + b + "," + opacity + ")";
    },
  },
  mounted() {
    this.getData();
  },
});
